import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from 'ui-library';

@Component({
  selector: 'app-coordinate',
  templateUrl: './coordinate.component.html',
  styleUrls: ['./coordinate.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    TranslateModule,
    MatToolbarModule,
    ButtonComponent
  ],
  standalone: true
})
export class CoordinateComponent implements OnInit, OnChanges {
  // Components API
  @Input() clickedMarkerInfo: any;
  @Input() showFloatingWindow: boolean = false;
  @Input() liveState: boolean | string = false;
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveData: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('mapLongitudeField') mapLongitudeField: any;
  @ViewChild('mapLatitudeField') mapLatitudeField: any;

  // Variables
  unit: any;
  lat: number = 0;
  lon: number = 0;
  trackerName: string = '';
  unitName: string = '';
  z: number = 0;

  constructor() { }

  ngOnInit() {
    this.loadData();
  }

  ngOnChanges(changes: any) {
    if (changes.clickedMarkerInfo && this.clickedMarkerInfo) {
      this.loadData();
    }
  }

  loadData() {
    this.unitName = this.clickedMarkerInfo.unit.name;
    this.trackerName = this.clickedMarkerInfo.name;
    this.lat = this.clickedMarkerInfo.lastTrack.lat;
    this.lon = this.clickedMarkerInfo.lastTrack.lon;
    this.z = this.clickedMarkerInfo.lastTrack.z;
  }

  isVirtualMarker(): boolean {
    return this.clickedMarkerInfo.unit.type === 'virtual';
  }

  save() {
    this.clickedMarkerInfo.unit.lastPosition.lat = this.lat;
    this.clickedMarkerInfo.unit.lastPosition.lon = this.lon;
    this.clickedMarkerInfo.unit.lastPosition.z = this.z;
    this.saveData.emit(this.clickedMarkerInfo);
  }

  onClose() {
    this.close.emit();
  }

}
